import { useTranslation } from "@redotech/redo-i18n";
import Printer from "@redotech/redo-icons/printer.svg";
import QrCode from "@redotech/redo-icons/qr-code-01.svg";
import { InteractiveMapLocation } from "@redotech/redo-model/draft-return/draft-return";
import { ReturnBearZod } from "@redotech/redo-model/return";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import {
  ReturnBearLocationsButton,
  ReturnBearLocationsSearchParams,
} from "./return-bear-locations-button";

export const ReturnBearLabelButtons = memo(function ReturnBearLabelButtons({
  returnBearDetails,
  returnId,
  autoOpen = false,
  searchReturnBearLocations,
  onOpenUrl,
}: {
  returnBearDetails: ReturnBearZod;
  returnId: string;
  autoOpen?: boolean;
  searchReturnBearLocations: (
    params: ReturnBearLocationsSearchParams,
  ) => Promise<InteractiveMapLocation[]>;
  onOpenUrl: (url: string) => void;
}) {
  const { t } = useTranslation();
  const qrCodeUri = returnBearDetails.qrCodeUri;
  const labelUri = returnBearDetails.shippingInfo?.shippingLabelUrl;

  return (
    <>
      {!!qrCodeUri && (
        <>
          <Flex>
            <RedoButton
              hierarchy="secondary"
              IconLeading={QrCode}
              onClick={() => onOpenUrl(qrCodeUri)}
              text={t("QR code")}
            />
          </Flex>
          <ReturnBearLocationsButton
            autoOpen={autoOpen}
            returnId={returnId}
            searchReturnBearLocations={searchReturnBearLocations}
          />
        </>
      )}

      {!!labelUri && (
        <Flex>
          <RedoButton
            hierarchy="secondary"
            IconLeading={Printer}
            onClick={() => onOpenUrl(labelUri)}
            text={t("Print label")}
          />
        </Flex>
      )}
    </>
  );
});
